import { Component, ElementRef, OnInit, ViewChild, Renderer2, Inject } from '@angular/core';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment.prod';
import { DOCUMENT } from '@angular/common';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';

declare var paypal: any;
declare var $: any;


@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['styles.css'
  ]
})
export class PlansComponent implements OnInit {

  @ViewChild('paypal0') paypalElement0 : ElementRef;
  @ViewChild('paypal1') paypalElement1 : ElementRef;
  @ViewChild('paypal2') paypalElement2 : ElementRef;
  @ViewChild('paypal3') paypalElement3 : ElementRef;
  @ViewChild('paypal4') paypalElement4 : ElementRef;

  public plans=[];
  public country;
  public working = false;
  public currency = ''
  public showSubscriptions = false;
  public anual = false;
  public user;


  constructor(
    private adminService:AdminServiceService,
    private userService:UserService,
    private _renderer2: Renderer2, 
    @Inject(DOCUMENT) private _document: Document,
    private route: ActivatedRoute
  ) {
    
    fetch(`${environment.apiBaseUrl}/plans/getPlans`).then(
      resp=>{
        resp.json().then(
          plans=>this.plans = plans
        )
      }
    )

  }

  ngOnInit(): void {

    this.userService.getUser().subscribe( resp => {
      this.user = resp;
      // console.log(this.user)
    })
  }
  
  ngAfterViewInit(){
    fetch('https://ipapi.co/json/').then(
      x=>x.json().then(
        ip=>{
          this.country = ip.country_code;

          // this.country = 'MX'

          // this.country = 'US'

          if(this.country!="AR"){
            
            let code;
            if (this.country=='MX') code = "MXN";
            if (this.country=='ES') code = "EUR";
            if (this.country!='ES'&&this.country!='MX') code = "USD";
            
            
            let script = this._renderer2.createElement('script');
            script.type = 'application/javascript';
            this.currency = code
            script.src = `https://www.paypal.com/sdk/js?client-id=AS1NDF8k-DthVhc9YkvK9fg8fCtS89CcohVPHssgfk9Ej8UzqUA-SXwJH66OI6Pk1Zj8HrBT51y5J65J&vault=true&currency=${this.currency}`;
            // script.src = `https://www.paypal.com/sdk/js?client-id=AX1ihw8GR8Z19WRZ_Qa9AHPavshMcQrfS9p76c_9HU896i4ve1SVlhBRmXbRfLtSoj4Pz1e-Lw_1j29_&vault=true&currency=${this.currency}`;
            this._renderer2.appendChild(this._document.body, script)
            setTimeout(()=>{
              this.renderPaypal();
              let view = this.route.snapshot.queryParamMap.get('view');
              if (view == 'subscriptions'){
                this.changeSubscriptionView()
              }
            },3000)
          }
        }
      )
    )
  }





  mpBuy(plan){

    this.userService.getUser().subscribe(
      resp=>{
        let data = {
          id:plan.type,
          title:plan.type,
          price:plan.price,
          email:resp.email
        }
        this.adminService.mpPayment(data).subscribe(
          resp=>{
            sessionStorage.setItem('paymentReturn', "true");
            window.location.href = resp;
          },
          err=>console.log(err)
        )

      },
      err=>console.log(err)
    )

  }

  mpSubscription(type: string, price: number, useCreator = false){
    if (useCreator){
      this.userService.updateUser({email:this.user.email, canUseTestCreator:true}).subscribe()
    }
    this.adminService.createMpSubscription(this.user.email, type, price).subscribe(
      resp => {
        location.href = resp.url;
      }
    )
  }

  renderPaypal(){
    let price = 0;
    let price2 = 0;
    let price3 = 0;
    let price4 = 0;
    let price5 = 0;
    if (this.country=='MX'){
      price = this.plans[0].mxn;
      price2 = this.plans[1].mxn;
      price3 = this.plans[2].mxn;
      price4 = this.plans[3].mxn;
      price5 = this.plans[4].mxn;
    }else if (this.country=='ES'){
            price = this.plans[0].eur;
            price2 = this.plans[1].eur;
            price3 = this.plans[2].eur;
            price4 = this.plans[3].eur;
            price5 = this.plans[4].eur;
          }else{
            price = this.plans[0].usd;
            price2 = this.plans[1].usd;
            price3 = this.plans[2].usd;
            price4 = this.plans[3].usd;
            price5 = this.plans[4].usd;
          }
    this.userService.getUser().subscribe(
      resp=>{

        paypal.Buttons({
          
          createOrder: (data, actions) =>{
            return actions.order.create({
              purchase_units:[
                {
                  description: `${this.plans[0].type};${resp.email}`,
                  amount:{
                    currency_code: this.currency,
                    value: price
                  }
                }
              ]
            })
          },
          onApprove: async (data, actions) => {
            $('#loadingModal').modal('show');
            this.working = true;
            const order = await actions.order.capture();
            var response = order.purchase_units[0].description.split(';');
            var product = response[0];
            var user = response[1];
            this.adminService.paypalPayment({type:product, email:user}).subscribe(
              resp=>{
                this.adminService.savePayment({email: user, desc:`PayPal - ${product} ${this.currency} ${price}`}).subscribe(
                  resp=>{
                    $('#loadingModal').modal('hide');
                    Swal.fire({
                      title: 'Tu pago a sido aceptado',
                      confirmButtonText: `Ok`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.reload();
                      } else if (result.isDenied) {
                        
                      }
                    })
                    this.working = false;
    
                  },
                  err=>console.log(err)
                )
              },
              err=>{
                console.log(err)
              }
            )
    
          },
          onError: err=>console.log(err)
    
        })
        .render(this.paypalElement0.nativeElement);
    
    
        paypal.Buttons({
          createOrder: (data, actions) =>{
            return actions.order.create({
              purchase_units:[
                {
                  description: `${this.plans[1].type};${resp.email}`,
                  amount:{
                    currency_code: this.currency,
                    value: price2
                  }
                }
              ]
            })
          },
          onApprove: async (data, actions) => {
            $('#loadingModal').modal('show');
            this.working = true;
            const order = await actions.order.capture();
            var response = order.purchase_units[0].description.split(';');
            var product = response[0];
            var user = response[1];
            this.adminService.paypalPayment({type:product, email:user}).subscribe(
              resp=>{
    
                this.adminService.savePayment({email: user, desc:`PayPal - ${product} ${this.currency} ${price2}`}).subscribe(
                  resp=>{
                    $('#loadingModal').modal('hide');
                    Swal.fire({
                      title: 'Tu pago a sido aceptado',
                      confirmButtonText: `Ok`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.reload();
                      } else if (result.isDenied) {
                        
                      }
                    })
                    this.working = false;
    
                  },
                  err=>console.log(err)
                )
              },
              err=>{
                console.log(err)
              }
            )
    
          },
          onError: err=>console.log(err)
    
        })
        .render(this.paypalElement1.nativeElement);
    
        paypal.Buttons({
      
          createOrder: (data, actions) =>{
            return actions.order.create({
              purchase_units:[
                {
                  description: `${this.plans[2].type};${resp.email}`,
                  amount:{
                    currency_code: this.currency,
                    value: price3
                  }
                }
              ]
            })
          },
          onApprove: async (data, actions) => {
            $('#loadingModal').modal('show');
            this.working = true;
            const order = await actions.order.capture();
            var response = order.purchase_units[0].description.split(';');
            var product = response[0];
            var user = response[1];
            this.adminService.paypalPayment({type:product, email:user}).subscribe(
              resp=>{
    
                this.adminService.savePayment({email: user, desc:`PayPal - ${product} ${this.currency} ${price3}`}).subscribe(
                  resp=>{
                    $('#loadingModal').modal('hide');
                    Swal.fire({
                      title: 'Tu pago a sido aceptado',
                      confirmButtonText: `Ok`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.reload();
                      } else if (result.isDenied) {
                        
                      }
                    })
                    this.working = false;
    
                  },
                  err=>console.log(err)
                )
              },
              err=>{
                console.log(err)
              }
            )
    
          },
          onError: err=>console.log(err)
    
        })
        .render(this.paypalElement2.nativeElement);
    
        paypal.Buttons({
      
          createOrder: (data, actions) =>{
            return actions.order.create({
              purchase_units:[
                {
                  description: `${this.plans[3].type};${resp.email}`,
                  amount:{
                    currency_code: this.currency,
                    value: price4
                  }
                }
              ]
            })
          },
          onApprove: async (data, actions) => {
            $('#loadingModal').modal('show');
            this.working = true;
            const order = await actions.order.capture();
            var response = order.purchase_units[0].description.split(';');
            var product = response[0];
            var user = response[1];
            this.adminService.paypalPayment({type:product, email:user}).subscribe(
              resp=>{
    
                this.adminService.savePayment({email: user, desc:`PayPal - ${product} ${this.currency} ${price4}`}).subscribe(
                  resp=>{
                    $('#loadingModal').modal('hide');
                    Swal.fire({
                      title: 'Tu pago a sido aceptado',
                      confirmButtonText: `Ok`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.reload();
                      } else if (result.isDenied) {
                        
                      }
                    })
                    this.working = false;
    
                  },
                  err=>console.log(err)
                )
              },
              err=>{
                console.log(err)
              }
            )
    
          },
          onError: err=>{
            console.log(err);
            Swal.fire({title:"Ha ocurrido un error",text:err}).then(
              resp=>window.location.reload()
            )
          }
    
        })
        .render(this.paypalElement3.nativeElement);

        paypal.Buttons({
      
          createOrder: (data, actions) =>{
            return actions.order.create({
              purchase_units:[
                {
                  description: `${this.plans[4].type};${resp.email}`,
                  amount:{
                    currency_code: this.currency,
                    value: price5
                  }
                }
              ]
            })
          },
          onApprove: async (data, actions) => {
            $('#loadingModal').modal('show');
            this.working = true;
            const order = await actions.order.capture();
            var response = order.purchase_units[0].description.split(';');
            var product = response[0];
            var user = response[1];
            this.adminService.paypalPayment({type:product, email:user}).subscribe(
              resp=>{
    
                this.adminService.savePayment({email: user, desc:`PayPal - ${product} ${this.currency} ${price5}`}).subscribe(
                  resp=>{
                    $('#loadingModal').modal('hide');
                    Swal.fire({
                      title: 'Tu pago a sido aceptado',
                      confirmButtonText: `Ok`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.reload();
                      } else if (result.isDenied) {
                        
                      }
                    })
                    this.working = false;
    
                  },
                  err=>console.log(err)
                )
              },
              err=>{
                console.log(err)
              }
            )
    
          },
          onError: err=>{
            console.log(err);
            Swal.fire({title:"Ha ocurrido un error",text:err}).then(
              resp=>window.location.reload()
            )
          }
    
        })
        .render(this.paypalElement4.nativeElement);

      },
      err=>console.log(err)
    )

    
  }

  sendEmailToDev(body: string, subject: string){
    this.userService.sendEmailFromClient(body, 'contacto@maximilianocalderon.com', subject).subscribe()
  }

  onSuscriptionApproved(userEmail: string, subscriptionId: string, canUseCustomTests: boolean, canUseTestCreator: boolean, subscriptionType: string, price: string){
    // console.log('onSuscriptionApproved', userEmail, subscriptionId, canUseCustomTests, canUseTestCreator, subscriptionType, price)
    // let body1 = `
    //   onSuscriptionApproved: ${userEmail} - ID${subscriptionId} - test:${canUseCustomTests} - creator:${canUseTestCreator} - ${subscriptionType} - ${price}
    // `
    // this.sendEmailToDev(body1, 'Suscripción PayPal');

    let today = new Date();
    let endDate = new Date();
    endDate.setMonth(endDate.getMonth() + subscriptionType == 'monthly' ? 1 : 12);
    let obj = {
      email: userEmail,
      subscriptionId,
      canUseCustomTests: true,
      canUseTestCreator,
      subscriptionType,
      subscriptionStart: today,
      subscriptionEnd: endDate
    }

    this.userService.updateUser(obj).subscribe( resp => {
      // console.log('User updated', resp);
      try {
        let body2 = `
          ${obj.email} ${obj.subscriptionId} - ${obj.canUseCustomTests} - ${obj.canUseTestCreator} - ${obj.subscriptionType} - ${this.currency} ${price}
        `
        this.sendEmailToDev(body2, 'Suscripción PayPal - User updated');
      } catch (error) {
        console.log(error)
        let body2 = `
          ${obj.email} ${obj.subscriptionId} - ${obj.canUseCustomTests} - ${obj.canUseTestCreator} - ${obj.subscriptionType} - ${this.currency} ${price}
        `
        this.sendEmailToDev(body2, 'Error Suscripción PayPal - User updated');
      }
      Swal.fire({
        title: 'Tu pago ha sido aceptado',
        confirmButtonText: `Ok`,
      }).then( async (_) => {
        try {
          let html = `
            <p>Nueva suscripción de ${obj.email}. ID PAYPAL: ${obj.subscriptionId}</p>
          `
          await this.userService.sendEmailFromClient(html, 'notificaciones@evaluapsi.com', 'Nueva suscripción').toPromise()
          let record = {
            email: userEmail,
            desc: `Suscripción PAYPAL ID ${subscriptionId} - ${this.currency} ${price}`
          }
          // console.log(record)
          await this.adminService.savePayment(record).toPromise()
          location.reload()
        } catch (error) {
          // console.log(error)
          location.reload()
          
        }
      })
    })




  }

  changeAnual(){
    this.anual = !this.anual;
    this.renderSubscriptionsButtons();
  }

  renderSubscriptionsButtons(){


// P-0W844565Y2763515JM6F5D2A
// Mensual evaluaciones USD

// P-8A266954GB770935AM6F5FEQ
// Mensual creador USD

// P-7B017818P04352437M6F5GGQ
// Anual evaluaciones USD

// P-2CJ49530G12859637M6F5G2Y
// Anual creador USD

// P-8824610123079534TM6F5HLY
// Mensual evaluaciones MXN

// P-4HC43655BP6762712M6F5H2Q
// Mensual creador MXN

// P-1AF53702JV1632638M6F5INY
// Anual evaluaciones MXN

// P-8FL65495RE148341RM6F5I3Y
// Anual creador MXN

// P-71E99047VA323135KM6F5JII
// Mensual evaluaciones EUR

// P-4MS00364L49728240M6F5J2A
// Mensual creador EUR

// P-5TF041881Y814693MM6F5KKY
// Anual evaluaciones EUR

// P-31D470748R173891YM6F5K2A
// Anual creador EUR

//P-45K76734U2561233FNBM6VBA
// TEST MX


//P-49P66563HS5599814NBTQS4Q
//TEST USD

    setTimeout(()=>{

      if (!this.anual){
        let planTestId = 'P-0W844565Y2763515JM6F5D2A';
        if (this.country == 'MX'){
          planTestId = 'P-8824610123079534TM6F5HLY';
        }
        if (this.country == 'ES'){
          planTestId = 'P-71E99047VA323135KM6F5JII';
        }

        let planCreatorId = 'P-8A266954GB770935AM6F5FEQ';

        if (this.country == 'MX'){
          planCreatorId = 'P-4HC43655BP6762712M6F5H2Q';
        }

        if (this.country == 'ES'){
          planCreatorId = 'P-4MS00364L49728240M6F5J2A';
        }

        // planTestId = 'P-49P66563HS5599814NBTQS4Q'

        


        paypal.Buttons({
          style: {
              shape: 'rect',
              color: 'gold',
              layout: 'vertical',
              label: 'subscribe'
          },
          intent: 'subscription',
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              /* Creates the subscription */
              plan_id: planTestId,
            });
          },
          onApprove: (data, actions) => {
            let price = this.plans[5].usd;
            if (this.country == 'ES') price = this.plans[5].eur;
            if (this.country == 'MX') price = this.plans[5].mxn;
            this.onSuscriptionApproved(this.user.email, data.subscriptionID, true, false, 'monthly', price);

          }
        }).render('#month-test-paypal');


        paypal.Buttons({
          style: {
              shape: 'rect',
              color: 'gold',
              layout: 'vertical',
              label: 'subscribe'
          },
          intent: 'subscription',
          createSubscription: function(data, actions) {
            return actions.subscription.create({
              /* Creates the subscription */
              plan_id: planCreatorId,
            });
          },
          onApprove: (data, actions) => {
            let price = this.plans[6].usd;
            if (this.country == 'ES') price = this.plans[6].eur;
            if (this.country == 'MX') price = this.plans[6].mxn;
            this.onSuscriptionApproved(this.user.email, data.subscriptionID, true, true, 'monthly', price);

          }
        }).render('#month-creator-paypal');

      }else{

        let planTestId = 'P-7B017818P04352437M6F5GGQ';
        if (this.country == 'MX'){
          planTestId = 'P-1AF53702JV1632638M6F5INY';
        }
        if (this.country == 'ES'){
          planTestId = 'P-5TF041881Y814693MM6F5KKY';
        }
        let planCreatorId = 'P-2CJ49530G12859637M6F5G2Y';
        if (this.country == 'MX'){
          planCreatorId = 'P-8FL65495RE148341RM6F5I3Y';
        }
        if (this.country == 'ES'){
          planCreatorId = 'P-31D470748R173891YM6F5K2A';
        }


        paypal.Buttons({
          style: {
              shape: 'rect',
              color: 'gold',
              layout: 'vertical',
              label: 'subscribe'
          },
          intent: 'subscription',

          createSubscription: function(data, actions) {
            return actions.subscription.create({
              /* Creates the subscription */
              plan_id: planTestId,
            });
          },
          onApprove: (data, actions) => {
            let price = this.plans[7].usd;
            if (this.country == 'ES') price = this.plans[7].eur;
            if (this.country == 'MX') price = this.plans[7].mxn;
            this.onSuscriptionApproved(this.user.email, data.subscriptionID, true, false, 'anual', price);
          }
        }).render('#anual-test-paypal');

        
        paypal.Buttons({
          style: {
              shape: 'rect',
              color: 'gold',
              layout: 'vertical',
              label: 'subscribe'
          },
          intent: 'subscription',

          createSubscription: function(data, actions) {
            return actions.subscription.create({
              /* Creates the subscription */
              plan_id: planCreatorId,
            });
          },
          onApprove: (data, actions) => {
            let price = this.plans[8].usd;
            if (this.country == 'ES') price = this.plans[8].eur;
            if (this.country == 'MX') price = this.plans[8].mxn;
            this.onSuscriptionApproved(this.user.email, data.subscriptionID, true, true, 'anual', price);
          }
        }).render('#anual-creator-paypal');
      }  
    }, 100)
  }

  changeSubscriptionView(){
    this.showSubscriptions = !this.showSubscriptions
    if (this.showSubscriptions){
      this.renderSubscriptionsButtons();
    }else{
      this.renderPaypal();
    }
  }

}
